export const TaskStatusOptions = [
    { value: 'DRAFT', label: 'Draft' },
    { value: 'PLANNED', label: 'Planned' },
    { value: 'ASSIGNED', label: 'Assigned' },
    { value: 'INITIATED', label: 'Initiated' },
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'ON_HOLD', label: 'On Hold' },
    { value: 'REOPENED', label: 'Reopened' },
    { value: 'UNDER_REVIEW', label: 'Under Review' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'APPROVED', label: 'Approved' },
    { value: 'REJECTED', label: 'Rejected' },
    { value: 'TERMINATED', label: 'Terminated' },
    { value: 'CANCELLED', label: 'Cancelled' },
  ];

  // constants/taskPriorities.ts
export const TASK_PRIORITIES = [
  { label: 'High', value: 'HIGH' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'Low', value: 'LOW' },
  { label: 'Urgent', value: 'URGENT' },
  { label: 'Blocker', value: 'BLOCKER' },
 // { label: 'Trivial', value: 'TRIVIAL' },
];
// public enum TaskPriority {
//   HIGH,
//   MEDIUM,
//   LOW,
//   URGENT,
//   BLOCKER,
//   TRIVIAL
// }

export const GENERAL_TASK_CATEGORIES = [
  {
    label: "General Task",
    value: "GENERAL_TASK",
    description: "Any adhoc work.",
    example: "Any adhoc work",
    useCases: ["Contract", "Insurance", "Legal Docs"],
  },
  {
    label: "Documentation",
    value: "DOCUMENTATION",
    description: "Tasks related to uploading, reviewing, or updating documents.",
    example: "Upload insurance document, contract PDF",
    useCases: ["Contract", "Insurance", "Legal Docs"],
  },
  {
    label: "Renewal",
    value: "RENEWAL",
    description: "Reminders to renew documents/services before expiration.",
    example: "Renew contract before expiry",
    useCases: ["Vehicle", "Insurance", "Contract"],
  },
  {
    label: "Maintenance",
    value: "MAINTENANCE",
    description: "Routine or scheduled maintenance work.",
    example: "Vehicle oil change, system health check",
    useCases: ["Vehicles", "IT Assets"],
  },
  {
    label: "Approval",
    value: "APPROVAL",
    description: "Tasks requiring user or role-based approvals.",
    example: "Approve contract, approve inventory disposal",
    useCases: ["Contracts", "Inventory", "Finance"],
  },
  {
    label: "Review",
    value: "REVIEW",
    description: "Tasks involving reviews or audits.",
    example: "Compliance check, legal review",
    useCases: ["Contracts", "GST", "Inventory"],
  },
  {
    label: "Follow-Up",
    value: "FOLLOW_UP",
    description: "Reminder or check-in tasks.",
    example: "Follow up with vendor, claim status",
    useCases: ["Insurance", "Contract", "Vendors"],
  },
  {
    label: "Alert",
    value: "ALERT",
    description: "System-triggered or time-sensitive alerts.",
    example: "GST deadline approaching, policy expiry alert",
    useCases: ["GST", "Insurance", "Compliance"],
  },
  {
    label: "Audit",
    value: "AUDIT",
    description: "Internal or external audit tasks.",
    example: "Inventory audit, vehicle audit",
    useCases: ["Inventory", "Vehicle"],
  },
  {
    label: "Escalation",
    value: "ESCALATION",
    description: "Urgent or overdue issues that need escalation.",
    example: "Escalated contract breach",
    useCases: ["Contracts", "Legal", "Support"],
  },
  {
    label: "Data Entry",
    value: "DATA_ENTRY",
    description: "Manual or structured entry of information.",
    example: "GST filing, inventory update",
    useCases: ["GST", "Inventory", "Compliance"],
  },
  {
    label: "System",
    value: "SYSTEM",
    description: "Tasks created by system rules, monitoring or IoT.",
    example: "Idle vehicle alert",
    useCases: ["Vehicle IoT", "Automation Engine"],
  }
];
